import React from 'react'
import PropTypes from 'prop-types'

import {
  Box,
  Typography,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from '@material-ui/core'

import { ExpandMore } from '@material-ui/icons'

const CardConfiguration = ({ image, title, collapse, children, ...rest }) => {
  if (!collapse) {
    return (
      <Box {...rest}>
        <Box display="flex" alignItems="center">
          <Box width={48} mr={2} component="img" src={image} />

          <Typography variant="h5" color="textSecondary">
            {title}
          </Typography>
        </Box>

        <Box py={{ xs: 2, sm: 4 }} px={{ xs: 0, sm: 8 }}>
          {children}
        </Box>
      </Box>
    )
  }

  return (
    <ExpansionPanel {...rest}>
      <ExpansionPanelSummary expandIcon={<ExpandMore />}>
        <Box display="flex" alignItems="center">
          <Box width={48} mr={2} component="img" src={image} />

          <Typography variant="h5" color="textSecondary">
            {title}
          </Typography>
        </Box>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <Box width="100%" px={{ xs: 0, sm: 8 }}>
          {children}
        </Box>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}

export default CardConfiguration

CardConfiguration.propTypes = {
  children: PropTypes.any,
}
